export const masters = [
	'Máster Arte Conceptual + IA',
	'Máster ZBrush para cinemáticas',
	'Máster ZBrush videojuegos personajes AAA',
	'Máster en Blender',
	'Máster ZBrush impresión',
	'Entrenamiento Blender impresión',
	'Máster ZBrush + CC5',
	'Máster Creación de Criaturas',
	'Entrenamiento jóvenes y niños',
	'Máster en Rigging',
	'Ninguno',
	'Otro',
];

export const inversion = [
	'Especialización Máster ($1,100 USD en adelante)',
	'Entrenamiento avanzado ($800 USD)',
	'Formación técnica ($500 USD)',
	'Curso de iniciación ($300 USD)',
];
